import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CommunicationNotification, MessageHistoryResponse } from '../model/login-response.dto';
import { ReservationDetails, TablesSection } from '../model/reservation';

@Injectable({
  providedIn: 'root'
})
export class CommunicationApiService {

  constructor(private httpClient: HttpClient) { }

  private baseUrl = `${environment.apiUrl}/communication`;

  sendMessage(restaurantId: number | string, notification: CommunicationNotification): Observable<any> {
    restaurantId = restaurantId.toString();

    const dataToSend: any = JSON.parse(JSON.stringify({
      restaurantId: restaurantId,
      bulkNotifications: [notification]
    }));    
    
    return this.httpClient.post<{ data: any }>(`${this.baseUrl}/sendNotificationsEnhanced`, dataToSend).pipe(
      map((data: any) => {
        return data;
      })
    );
  }

  getNotifications(restaurantId: number | string, reservationId: string): Observable<MessageHistoryResponse> {
    restaurantId = restaurantId.toString();

    const dataToSend: any = JSON.parse(JSON.stringify({
      restaurantId: restaurantId,
      bulkNotifications: [
          { reservationId: reservationId }
      ]
    }));    
    
    return this.httpClient.post<{ data: any }>(`${this.baseUrl}/retrieveNotificationsEnhanced`, dataToSend).pipe(
      map((data: any) => {
        return data;
      })
    );
  }
}
